<template>
  <div class="loader">
    <div ref="pieloader" :hidden="pieHidden"></div>
    <div ref="barloader" :hidden="barHidden"></div>
  </div>
</template>
<script>
import lottie from 'lottie-web';
import pieAnimation from './pie';
import barAnimation from './bar';

export default {
  data() {
    return {
      pieHidden: false,
      barHidden: true
    };
  },
  mounted() {
    const pieEvent = lottie.loadAnimation({
      container: this.$refs.pieloader, // the dom element that will contain the animation
      renderer: 'svg',
      autoplay: false,
      loop: false,
      animationData: pieAnimation // the path to the animation json
    });
    const barEvent = lottie.loadAnimation({
      container: this.$refs.barloader, // the dom element that will contain the animation
      renderer: 'svg',
      autoplay: false,
      loop: false,
      animationData: barAnimation // the path to the animation json
    });
    pieEvent.addEventListener('complete', () => {
      pieEvent.stop();
      this.pieHidden = true;
      this.barHidden = false;
      barEvent.play();
    });
    barEvent.addEventListener('complete', () => {
      barEvent.stop();
      this.pieHidden = false;
      this.barHidden = true;
      pieEvent.play();
    });
    pieEvent.play();
  },
  methods: {
    animate() {}
  }
};
</script>
<style lang="scss" scoped>
.loader > div {
  height: 100%;
}
</style>
